import { render, staticRenderFns } from "./ParceriasForm.vue?vue&type=template&id=f7d2f300"
import script from "./ParceriasForm.vue?vue&type=script&lang=js"
export * from "./ParceriasForm.vue?vue&type=script&lang=js"
import style0 from "./ParceriasForm.vue?vue&type=style&index=0&id=f7d2f300&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports